import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useLocation, useParams } from 'react-router'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ListGroup from 'react-bootstrap/ListGroup'
import Button from 'react-bootstrap/Button'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import YearSelector from '../../Oscars/YearSelector'
import * as s from './CinderellaDeletedEntryLog.scss'
import { getDeletedEntryLog } from '@severed-links/common.redherrings-reducers/cinderellaAdmin'
import moment from 'moment-timezone'
import PlayerListItem from '../../Player/PlayerListItem'
import Modal from '@severed-links/common.modal'

const CinderellaDeletedEntryLog = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()
    const { year } = params || {}
    const { playerId } = useSelector(state => state.account)
    const { year: contestYear } = useSelector(state => state.cinderella)
    const { deletedEntryLog } = useSelector(state => state.cinderellaAdmin)
    const [isLoading, setLoading] = useState(false)
    const [detail, setDetail] = useState(null)

    useEffect(() => {
        if (year && !isNaN(year)) {
            loadLog(year)
        }
    }, [year])

    useEffect(() => {
        if (!year && !isNaN(contestYear)) {
            navigate(`/cinderella/admin/deleted-entries/${contestYear}`)
        }
    }, [contestYear, year])

    const loadLog = () => {
        setLoading(true)
        dispatch(getDeletedEntryLog(year))
        .then(() => setLoading(false))
    }

    const handleLogItemClick = _item => {
        setDetail(_item)
    }

    return (
        <div className={s.container}>
            <Row>
                <Col xs={12}>
                    <div className={s.titleContainer}>
                        <h2 className={s.title}>
                            {year} Deleted Entry Log {isLoading ? <FontAwesomeIcon name='circle-notch' spin /> : null}
                        </h2>
                        <div className={s.refreshButton} title='reload log'>
                            <Button onClick={() => loadLog(true)}><FontAwesomeIcon name='rotate' spin={isLoading} /> reload log</Button>
                        </div>
                        <div className={s.paymentsYearSelector} title='change year'>
                            <YearSelector defaultYear={year} 
                                buttonTitle={null} buttonIcon={'calendar'} />
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <ListGroup className={s.list}>
                    {deletedEntryLog && deletedEntryLog.map(i =>
                        <PlayerListItem key={`deleted-entry-${i._id}`} 
                            className={s.item} player={i}
                            rightDetail={i.dateDeleted ?
                            <div className={s.rightDetail}>
                                <div>{moment(i.dateDeleted).format('MMM D YYYY')}</div>
                                <div>{moment(i.dateDeleted).format('h:mm:ss A')}</div>
                            </div>
                            : null}
                            onClick={() => handleLogItemClick(i)} />
                    )}
                    {!isLoading && !deletedEntryLog?.length ?
                    <ListGroup.Item className={s.item + ' ' + s.noRecords}>
                        No deleted entries for {year}.
                    </ListGroup.Item>
                    : null}
                    </ListGroup>
                </Col>
            </Row>
            <Modal show={!!detail} onClose={() => setDetail(null)}
                heading={'Log Item Detail'} showFooter={false}>
            <div>
                {detail ? 
                <div>
                    <PlayerListItem player={detail}
                    rightDetail={detail.dateDeleted ?
                            <div className={s.rightDetail}>
                                <div>{moment(detail.dateDeleted).format('MMM D YYYY')}</div>
                                <div>{moment(detail.dateDeleted).format('h:mm:ss A')}</div>
                            </div>
                            : null} />
                    {detail.entryTeams?.length ?
                    <div>
                        <h4>Teams</h4>
                        <div>Need to show teams!</div>
                    </div>
                    : <div>No teams located in log.</div>}
                </div>
                : null}
            </div>
            </Modal>
        </div>
    )
}

export default CinderellaDeletedEntryLog
